module.exports = __webpack_public_path__ + "media/E8.48680409.wav";